import type { ProyectoPlan } from '../tipos'
import type { RangoPyg } from './tipos'
import { etiquetaMes } from './devengado'
import estilos from './PygProyectos.module.css'

type Props = {
  proyectos: ProyectoPlan[]
  proyectoIdSeleccionado: string | null
  onSeleccionarProyecto: (id: string | null) => void
  mesesDisponibles: string[]
  mesActualClave: string
  onSeleccionarMes: (clave: string) => void
  rango: RangoPyg
  onCambiarRango: (rango: RangoPyg) => void
}

export function BarraControlPyg({
  proyectos,
  proyectoIdSeleccionado,
  onSeleccionarProyecto,
  mesesDisponibles,
  mesActualClave,
  onSeleccionarMes,
  rango,
  onCambiarRango,
}: Props) {
  const indiceActual = mesesDisponibles.indexOf(mesActualClave)
  const puedeAnterior = indiceActual > 0
  const puedeSiguiente = indiceActual >= 0 && indiceActual < mesesDisponibles.length - 1

  function irAnterior() {
    if (puedeAnterior) {
      onSeleccionarMes(mesesDisponibles[indiceActual - 1])
    }
  }

  function irSiguiente() {
    if (puedeSiguiente) {
      onSeleccionarMes(mesesDisponibles[indiceActual + 1])
    }
  }

  return (
    <div className={estilos.barraControl}>
      <div className={estilos.grupoIzquierda}>
        <div className={estilos.selectorProyecto}>
          <label htmlFor="select-proy-pyg" className={estilos.kpiTitulo}>
            Proyecto:
          </label>
          <select
            id="select-proy-pyg"
            className={estilos.selectInput}
            value={proyectoIdSeleccionado || 'todos'}
            onChange={(e) => onSeleccionarProyecto(e.target.value === 'todos' ? null : e.target.value)}
          >
            <option value="todos">Consolidado (Todos los proyectos)</option>
            {proyectos.map((p) => (
              <option key={p.id} value={p.id}>
                {p.codigo} · {p.nombre} {p.cliente ? `(${p.cliente})` : ''}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className={estilos.grupoDerecha}>
        {/* Selector de Mes con Flechas */}
        <div className={estilos.selectorMes} aria-label="Selector de mes analizado">
          <button
            type="button"
            className={estilos.btnMesNav}
            onClick={irAnterior}
            disabled={!puedeAnterior}
            title="Mes anterior"
          >
            ‹
          </button>
          <span className={estilos.mesActualEtiqueta}>
            {etiquetaMes(mesActualClave)}
          </span>
          <button
            type="button"
            className={estilos.btnMesNav}
            onClick={irSiguiente}
            disabled={!puedeSiguiente}
            title="Mes siguiente"
          >
            ›
          </button>
        </div>

        {/* Selector de Rango (Pills) */}
        <div className={estilos.selectorRango} role="group" aria-label="Rango de agregación">
          <button
            type="button"
            className={`${estilos.pillRango} ${rango === 'mes' ? estilos.pillRangoActivo : ''}`}
            onClick={() => onCambiarRango('mes')}
          >
            Mes
          </button>
          <button
            type="button"
            className={`${estilos.pillRango} ${rango === 'trim' ? estilos.pillRangoActivo : ''}`}
            onClick={() => onCambiarRango('trim')}
          >
            Trimestre
          </button>
          <button
            type="button"
            className={`${estilos.pillRango} ${rango === 'ano' ? estilos.pillRangoActivo : ''}`}
            onClick={() => onCambiarRango('ano')}
          >
            Año
          </button>
          <button
            type="button"
            className={`${estilos.pillRango} ${rango === 'todo' ? estilos.pillRangoActivo : ''}`}
            onClick={() => onCambiarRango('todo')}
          >
            Todo
          </button>
        </div>
      </div>
    </div>
  )
}
